'use client';

import Image from 'next/image';

import { CMSBlockTitle } from '../cms-block-title';
import { CMSBlockWrapper } from '../cms-block-wrapper';

import css from './presentation-slide-block-view.css';

import type { PresentationSlideBlockViewModel } from '../../view-models/blocks/presentation-slide-block.viewModel';

export function PresentationSlideBlockView({
  title,
  hide,
  fieldImage
}: PresentationSlideBlockViewModel) {
  const isVideo =
    fieldImage?.filename?.endsWith('.mp4') || fieldImage?.uri?.value?.endsWith('.webm');

  return (
    <CMSBlockWrapper>
      {title && <CMSBlockTitle value={title} />}
      <div>
        {hide
          ? null
          : fieldImage &&
            (isVideo ? (
              <video
                src={fieldImage.uri.value}
                controls
                width={1920}
                height={700}
                className={css.video}
                poster={fieldImage?.imageStyleUri?.background}
              />
            ) : (
              <Image
                src={fieldImage.uri.value}
                alt={fieldImage?.meta?.alt || ''}
                title={fieldImage?.meta?.title || ''}
                width={1920}
                height={700}
              />
            ))}
      </div>
    </CMSBlockWrapper>
  );
}
